import { ConnectEmailDialog } from '@modules/_shared/components/email-connect/ConnectEmailDialog';
import { useActivityContext } from '@modules/_shared/components/feed/ActivityProvider';
import { useEmailConnectedRefresh } from '@modules/_shared/hooks/useEmailConnectedRefresh';
import { useHasValidNylasAccount } from '@modules/_shared/hooks/useHasValidNylasAccount';

export const EmailFormWrapper = () => {
  const { emailDialogOpen, closeEmailDialog, EmailFormComponent } =
    useActivityContext();
  const hasValidNylasAccount = useHasValidNylasAccount();
  const onEmailConnected = useEmailConnectedRefresh();

  if (!emailDialogOpen) {
    return null;
  }

  if (!hasValidNylasAccount) {
    return (
      // Re-read `me` instead of reloading: the dialog stays open and swaps
      // straight to the compose form the user came for. Both outcomes hand
      // off to `useEmailConnectedRefresh`, which owns the reload.
      <ConnectEmailDialog
        open={emailDialogOpen}
        onClose={closeEmailDialog}
        onSuccess={onEmailConnected}
        onError={closeEmailDialog}
      />
    );
  }

  if (!EmailFormComponent) {
    return null;
  }

  return <EmailFormComponent onClose={closeEmailDialog} />;
};
